// extracted by mini-css-extract-plugin
export default {"Headline":"OngoingLoanView_Headline","decimalsWithSeparator":"OngoingLoanView_decimalsWithSeparator"};